function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
  fill: "#10BA97"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M96.5609 141.8H74.9609L86.0009 119.72H98.4809C101.841 101.32 109.041 87.3199 120.081 77.7199C131.121 67.9599 144.961 63.08 161.601 63.08C184.321 63.08 200.641 72.1999 210.561 90.4399L189.441 102.44C182.561 91.24 173.281 85.6399 161.601 85.6399C141.121 85.6399 128.641 97 124.161 119.72H175.281L164.241 141.8H122.001V156.2H175.281L164.241 178.28H124.161C128.641 201 141.121 212.36 161.601 212.36C173.281 212.36 182.561 206.76 189.441 195.56L210.561 207.56C200.641 225.8 184.321 234.92 161.601 234.92C144.961 234.92 131.121 230.12 120.081 220.52C109.041 210.76 101.841 196.68 98.4809 178.28H74.9609L86.0009 156.2H96.5609V141.8Z",
  fill: "white"
});

var SvgEur = function SvgEur(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEur, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EUR.657f21e5.svg";
export { ForwardRef as ReactComponent };